/* Recently viewed parts.

   WHERE THE RECORD COMES FROM. Every part in the grid is a
   .vin-fx-diagram-card carrying data-product-key, which is the product handle,
   plus its title, photograph, price and stock. A diagram card uses the same
   class and has no price, so the presence of a price is what separates a part
   from a diagram. Nothing needs to be fetched to record a view.

   PRICE IS THE SNAPSHOT, STOCK IS REFRESHED. The price shown is the price the
   customer actually saw on the card, which is already correct for whoever they
   are logged in as. Re-fetching it would replace a dealer's price with the
   retail one, so it is left alone. Availability is the one field that can turn
   a good strip into a bad experience, so that is refreshed from
   /products/<handle>.js, which is same origin and cached.

   THE STRIP RESETS WITH THE TRAILER. Parts are trailer specific and a strip
   carried over from another trailer can offer something that does not fit. The
   trailer signature is stored beside the items; when it changes the items go.

   Four items, one row, no scroller. The fifth pushes the oldest out. Four
   rather than five because the hero is a 760px column, not the full page
   width, and five cards in it came out at 139px with the price clipped. */
(function () {
  'use strict';

  var KEY = 'fxSeenParts';
  var MAX = 4;
  var frame = 0;
  var painted = '';

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || 'null') || { t: '', items: [] }; }
    catch (e) { return { t: '', items: [] }; }
  }
  function write(v) {
    try { window.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function txt(root, sel) {
    var n = root.querySelector(sel);
    return n ? (n.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function trailerSig() {
    try {
      var d = JSON.parse(window.localStorage.getItem('trailerData') || 'null');
      if (d && d.modelName) return String(d.modelName) + '|' + String(d.vinModelYear || '') + '|' + String(d.vinNumber || '');
    } catch (e) {}
    return '';
  }

  /* ---- recording ------------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.vin-fx-diagram-card') : null;
    if (!card) return;
    var key = card.getAttribute('data-product-key');
    if (!key) return;
    var priceNode = card.querySelector('.vin-fx-card-price');
    if (!priceNode) return; /* a diagram, not a part */

    var img = card.querySelector('img');
    var rec = {
      k: key,
      t: txt(card, '.diagram-title'),
      p: txt(card, '.vin-price-now') || txt(card, '.vin-fx-card-price'),
      w: txt(card, '.vin-price-was'),
      s: txt(card, '.vin-fx-card-stock'),
      img: img ? (img.currentSrc || img.src || '') : '',
      at: Date.now()
    };
    if (!rec.t) return;

    var store = read();
    var sig = trailerSig();
    if (store.t !== sig) { store = { t: sig, items: [] }; }
    store.items = store.items.filter(function (x) { return x.k !== rec.k; });
    store.items.unshift(rec);
    store.items = store.items.slice(0, MAX);
    write(store);
    painted = '';
    schedule();
  }, true);

  /* ---- availability, the one field worth refreshing ------------------- */

  var stockCache = {};
  function refreshStock(rec, dot, label) {
    if (stockCache[rec.k] !== undefined) { apply(stockCache[rec.k]); return; }
    fetch('/products/' + encodeURIComponent(rec.k) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var ok = !!(j && j.available);
        stockCache[rec.k] = ok;
        apply(ok);
      })
      .catch(function () {});
    function apply(ok) {
      label.textContent = ok ? 'In stock' : 'Out of stock';
      dot.parentNode.classList.toggle('is-out', !ok);
      var add = dot.parentNode.parentNode.querySelector('.fx-sn__add');
      if (add) add.textContent = ok ? 'Add' : 'Notify me';
    }
  }

  /* ---- add to cart ---------------------------------------------------- */

  function addToCart(rec, button) {
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';
    fetch('/products/' + encodeURIComponent(rec.k) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var v = j && j.variants && j.variants.filter(function (x) { return x.available; })[0];
        if (!v) throw new Error('unavailable');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('add failed');
        button.textContent = 'Added';
        bumpCart();
        setTimeout(function () { button.textContent = original; button.disabled = false; }, 1600);
      })
      .catch(function () {
        button.textContent = 'View part';
        button.disabled = false;
        window.location.href = '/products/' + rec.k;
      });
  }

  /* Dawn keeps the count in #cart-icon-bubble and refreshes it from a section
     render, which is the same route the theme's own add to cart uses. */
  function bumpCart() {
    fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j['cart-icon-bubble']) return;
        var host = document.getElementById('cart-icon-bubble');
        if (!host) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = j['cart-icon-bubble'];
        var next = tmp.querySelector('#cart-icon-bubble');
        if (next) host.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  /* ---- render --------------------------------------------------------- */

  function card(rec) {
    var a = el('a', 'fx-sn__card');
    a.href = '/products/' + rec.k;

    var pic = el('span', 'fx-sn__pic');
    if (rec.img) {
      var im = document.createElement('img');
      im.src = rec.img;
      im.alt = '';
      im.loading = 'lazy';
      /* A part whose photograph has been replaced since it was viewed leaves
         the grey well rather than a broken image icon. */
      im.addEventListener('error', function () { pic.textContent = ''; });
      pic.appendChild(im);
    }
    a.appendChild(pic);

    var b = el('span', 'fx-sn__b');
    b.appendChild(el('span', 'fx-sn__t', rec.t));

    var price = el('span', 'fx-sn__price');
    if (rec.w) price.appendChild(el('s', 'fx-sn__was', rec.w));
    price.appendChild(el('span', 'fx-sn__now', rec.p));
    b.appendChild(price);

    var stock = el('span', 'fx-sn__stock');
    var dot = el('i');
    var label = el('span', null, rec.s || 'In stock');
    stock.appendChild(dot);
    stock.appendChild(label);
    b.appendChild(stock);

    var add = el('button', 'fx-sn__add', 'Add');
    add.type = 'button';
    add.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(rec, add);
    });
    b.appendChild(add);

    a.appendChild(b);
    refreshStock(rec, dot, label);
    return a;
  }

  function paint() {
    var store = read();
    var sig = trailerSig();
    if (sig && store.t && store.t !== sig) {
      write({ t: sig, items: [] });
      store = { t: sig, items: [] };
    }

    /* After everything in the hero: the picked trailer, the I do not know my
       model panel and the browse links, so the strip lands between the whole
       Find your trailer block and Get your parts in 3 steps. Anchoring any
       higher wedges it between a control and the thing that control belongs
       to. */
    var anchor = document.querySelector('.vin-search-hero-actions .browse-row') ||
                 document.querySelector('.vin-hero-ident') ||
                 document.querySelector('.vin-hero-pick');
    var host = document.querySelector('.fx-sn');

    if (!store.items.length || !anchor) {
      if (host && host.parentNode) host.parentNode.removeChild(host);
      painted = '';
      return;
    }

    if (!host) host = el('section', 'fx-sn');
    if (host.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', host);

    var sigPaint = store.items.map(function (x) { return x.k; }).join(',');
    if (painted === sigPaint && host.firstChild) return;
    painted = sigPaint;
    host.textContent = '';

    var head = el('div', 'fx-sn__head');
    head.appendChild(el('h2', null, 'Recently viewed'));
    var clear = el('button', 'fx-sn__clear', 'Clear');
    clear.type = 'button';
    clear.addEventListener('click', function () {
      write({ t: trailerSig(), items: [] });
      painted = '';
      schedule();
    });
    head.appendChild(clear);
    host.appendChild(head);

    var cards = el('div', 'fx-sn__cards');
    store.items.forEach(function (rec) { cards.appendChild(card(rec)); });
    host.appendChild(cards);
  }

  /* setTimeout, not requestAnimationFrame. rAF is paused while a tab is
     hidden, so a strip recorded in a background tab would sit unpainted until
     the tab came forward. A 16ms timeout coalesces just as well and does not
     care whether anybody is looking. */
  function schedule() { if (!frame) frame = setTimeout(function () { frame = 0; paint(); }, 16); }

  function start() {
    paint();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    /* The safety net. If the extension finishes rendering before the observer
       is attached there is no further mutation to react to, and the strip
       would sit unpainted until something else moved. paint returns early
       once it has nothing to do, so this costs nothing. */
    setInterval(schedule, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
